// The setup screen's DesignerCatalog: the shared column editors (designerKit)
// read tables and columns through the UdaTransport's read-only
// `catalog/tables` + `catalog/columns` (the tenant data DB's tables the
// caller's organization sees, twasta_* excluded), the same on every host.
// Messages go to the screen's own notice strip; dialogs use the kit's shell.

import type { DesignerCatalog, KitNotifyKind } from '../../designerKit/catalog'
import type { UdaTransport } from '../types'

export function udaDesignerCatalog(transport: UdaTransport, objName: string,
  notify: (kind: KitNotifyKind, message: string) => void): DesignerCatalog {
  return {
    async tables() {
      const r = await transport.catalogTables(objName)
      return (r?.tables || []).map(t => ({ name: t.name }))
    },
    async columns(table: string) {
      const r = await transport.catalogColumns(objName, table)
      return r?.columns || []
    },
    notify,
  }
}
